import React, { useRef } from "react";

export interface U3141DocumentFileUploadProps {
  label?: string;
  value: File | null;
  onChange: (file: File | null) => void;
  accept?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * Composant de sélection de fichier pour l'upload de documents (onglet Documents, popup Add).
 * Expose le File sélectionné pour l'envoi dans le POST multipart.
 */
export const U3141DocumentFileUpload: React.FC<U3141DocumentFileUploadProps> = ({
  label,
  value,
  onChange,
  accept = ".pdf,application/pdf",
  disabled = false,
  className = "",
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    onChange(file);
  };

  const handleClear = () => {
    onChange(null);
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className={className}>
      {label && (
        <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="u3141-document-file">
          {label}
        </label>
      )}
      <div className="flex items-center gap-2">
        <input
          id="u3141-document-file"
          ref={inputRef}
          type="file"
          accept={accept}
          disabled={disabled}
          onChange={handleChange}
          className="block w-full text-sm text-gray-500 file:mr-4 file:rounded-sm file:border-0 file:bg-gray-100 file:px-4 file:py-2 file:text-sm file:font-medium file:text-gray-700 hover:file:bg-gray-200"
        />
        {value && (
          <span className="text-sm text-gray-600">
            {value.name}
            <button
              type="button"
              onClick={handleClear}
              disabled={disabled}
              className="ml-2 text-red-600 hover:underline"
            >
              (retirer)
            </button>
          </span>
        )}
      </div>
    </div>
  );
};
